"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simulateAnchorClick = void 0;
var simulateAnchorClick = function simulateAnchorClick(href) {
  var a = document.createElement('a');
  a.href = href;
  a.target = '_blank';
  a.click();
};
exports.simulateAnchorClick = simulateAnchorClick;